import { SimpleTextAPI } from '../../../api/genericLayout/SimpleTextAPI';

export class SimpleTextCommand {
    constructor(appName) {
        this.simpleTextApi = new SimpleTextAPI(appName);
    }

    getAll(successCallback, errorCallback) {
        const apiResult = this.simpleTextApi.list();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os dados");
            }
        });
    }

    save(data, successCallback, errorCallback) {
        if (0 >= data.text.length) {
            return;
        }

        const dataToSend = {
            id: data.id,
            text: data.text,
            rotationAngle: data.rotationAngle,
            opacity: data.opacity,
            textCase: data.textCase,
            textToRemove: data.textToRemove
        }

        let apiResult = undefined;
        if (0 === dataToSend.id) {
            apiResult = this.simpleTextApi.create(dataToSend);
        }
        else {
            apiResult = this.simpleTextApi.update(dataToSend.id, dataToSend);
        }

        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu a criar o texto");
            }
        });
    }

    delete(simpleTextId, successCallback, errorCallback) {
        const apiResult = this.simpleTextApi.delete(simpleTextId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback("Texto eliminado com sucesso");
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a eliminar o texto");
            }
        });
    }
}
